import { useMemo } from "react";
import { useExpenseQuery } from "web_myplann/Api/Finances/useExpenseQuery";
import { useIncomeQuery } from "web_myplann/Api/Finances/useIncomeQuery";
import { mapExpenseDto } from "web_myplann/Finances/Helpers/mapExpenseDto";
import { mapIncomeDto } from "web_myplann/Finances/Helpers/mapIncomeDto";
import { sumIncomeAmounts } from "web_myplann/Finances/Helpers/sumIncomeAmounts";
import { sumMonthlyPayments } from "web_myplann/Finances/Helpers/sumMonthlyPayments";

export const useFinanceEntries = () => {
	const {
		data: income,
		isSuccess: isIncomeSuccess,
		isLoading: isIncomeLoading,
		isPending: isIncomePending,
		isError: isIncomeError,
	} = useIncomeQuery();
	const {
		data: expenses,
		isSuccess: isExpensesSuccess,
		isLoading: isExpensesLoading,
		isPending: isExpensesPending,
		isError: isExpensesError,
	} = useExpenseQuery();

	const incomeEntries = useMemo(
		() => income?.data?.map(mapIncomeDto) ?? [],
		[income?.data],
	);
	const expenseEntries = useMemo(
		() => expenses?.data?.map(mapExpenseDto) ?? [],
		[expenses?.data],
	);

	return {
		incomeEntries,
		expenseEntries,
		totalIncome: sumIncomeAmounts(incomeEntries),
		totalExpenses: sumMonthlyPayments(expenseEntries),
		hasIncomeData: Array.isArray(income?.data),
		hasExpenseData: Array.isArray(expenses?.data),
		isSuccess: isIncomeSuccess && isExpensesSuccess,
		isLoading: isIncomeLoading || isExpensesLoading,
		isPending: isIncomePending || isExpensesPending,
		isError: isIncomeError || isExpensesError,
	};
};
